import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchFilter',
    standalone: false
})
export class SearchFilterPipe implements PipeTransform {
  /**
   * ex <ul>
          <li *ngFor="let item of items | searchFilter:searchTerm:['name', 'email']">{{item.name}} ({{item.email}})</li>
        </ul>
   * @param items
   * @param term
   * @param properties
   * @returns
   */
  transform(items: any[], term: string, properties: string[]): any[] {
    if (!items) return [];
    if (!term) return items;
    term = term.toLowerCase();
    return items.filter(item => {
      for (let property of properties) {
        if (item[property] && item[property].toLowerCase().includes(term)) {
          return true;
        }
      }
      return false;
    });
  }
}
